var React = require('react');

function LocationIconBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 16C6 16 12 10.4 12 5.6C12 2.50721 9.31371 0 6 0C2.68629 0 0 2.50721 0 5.6C0 10.24 6 16 6 16ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9Z","fill":"#333333"}));
}

LocationIconBlack.defaultProps = {"width":"12","height":"16","viewBox":"0 0 12 16","fill":"none"};

module.exports = LocationIconBlack;

LocationIconBlack.default = LocationIconBlack;
